import { I18nComponente } from "@/types/gerais"

export const GestaoTravamentoi18n: I18nComponente = {
  "pt-BR": {
    gestaoDeTravamentos: "gestão de travamentos",
  },
  "es-CO": {
    gestaoDeTravamentos: "control de congelamientos",
  }
}
